export abstract class Constants {
    static readonly REQUEST_URL: string = "https://api.bookinglab.co.uk/publicHolidays/ie";
    static readonly API_KEY: string = "api_key";
    static readonly API_KEY_VALUE: string = "c5795c040db2d5d1f788e9bc23022bb257ca4a7b";
    static readonly IRELAND_ISO_3166: string = "IE";
    static readonly COUNTRY: string = "country";
    static readonly YEAR: string = "year";
}